<template>
    <div id="FPS-Report 2">
        <div class="container  admin-wrap mt-5">
            <div class="row header mb-3">
                <div class="col-lg-5 ">
                    <h3 class="text-left ">FPS REPORT NEW FORMAT</h3>
                </div>
            </div>
            <div>
                <div class="tl-search-bar">
                    <el-date-picker
                    v-model="inputFromDate"
                    type="daterange"
                    range-separator="TO"
                    start-placeholder="From Date"
                    end-placeholder="To Date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy">
                    </el-date-picker>
                    <!--<el-select v-model="inputDateMonth" placeholder="Please select Date Month">-->
                        <!--<el-option v-for="item in DateMonthOptions" :key="item.value"-->
                                   <!--:label="item.label" :value="item.value">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <!--<el-select v-model="inputDateYear" placeholder="Please select year">-->
                        <!--<el-option v-for="item in DateYearOptions" :key="item.value"-->
                                   <!--:label="item.label" :value="item.value">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <el-button class="" v-on:click="Search()">Search </el-button>
                </div>
                <div class="empty-list_image"
                     v-if="FPSListInt.length<1">
                    <!--<strong>{{startupText}}</strong>-->
                    <img src="../assets/notfound.png"/>
                </div>
                <div class="">
                    <div v-if="FPSListInt.length>0" class="datatable_group">
                        <el-button size="small" type="primary" icon="el-icon-download" v-on:click="DownloadExcel()"
                                   class="pull-right mb-3">Download
                        </el-button>
                        <data-tables :data="FPSListInt" :page-size="pageSize"
                                     :pagination-props="{ pageSizes: [pageSize,100] }"
                                     width="55" stripe tooltip-effect='light' border
                                     ref="FPSListTable">
                            <el-table-column label="#" min-width="45px">
                                <template slot-scope="scope">
                                    {{(scope.$index)+1}}
                                </template>
                            </el-table-column>
                            <el-table-column v-for="(item) in FPSList"
                                             min-width="150px"
                                             :prop="item.prop"
                                             :label="item.label"
                                             :key="item.prop"
                                             sortable="custom">
                            </el-table-column>
                        </data-tables>
                    </div>

                </div>
            </div>
            <!--<div class="empty-list_image"-->
            <!--v-if="FPSListInt.length<1">-->
            <!--&lt;!&ndash;<strong>{{startupText}}</strong>&ndash;&gt;-->
            <!--<img src="../assets/notfound.png"/>-->
            <!--</div>-->
        </div>
    </div>
</template>
<script>
    import DataSource from "../data/datasource";
    import Cookies from "js-cookie";
    import XLSX from 'xlsx';

    export default {
        name: "FPSReport2",
        async created() {
            // this.schoolID = Cookies.get('schoolSession');
            // console.log('1: ',this.schoolID);
            // await this.BindFPSReport();
        },
        async mounted()
        {


        },
        data() {
            return {
                // inputDateMonth: '',
                // inputDateYear: '',
                // DateYearOptions: [{
                //     value: new Date().getFullYear() - 1 ,
                //     label: new Date().getFullYear() - 1
                // }, {
                //     value: new Date().getFullYear() ,
                //     label: new Date().getFullYear()
                // }],
                // DateMonthOptions: [{
                //     value: '1',
                //     label: 'Jan'
                // }, {
                //     value: '2',
                //     label: 'Feb'
                // }, {
                //     value: '3',
                //     label: 'March'
                // }, {
                //     value: '4',
                //     label: 'April'
                // }, {
                //     value: '5',
                //     label: 'May'
                // }, {
                //     value: '6',
                //     label: 'June'
                // }, {
                //     value: '7',
                //     label: 'July'
                // }, {
                //     value: '8',
                //     label: 'Aug'
                // }, {
                //     value: '9',
                //     label: 'Sept'
                // }, {
                //     value: '10',
                //     label: 'Oct'
                // }, {
                //     value: '11',
                //     label: 'Nov'
                // }, {
                //     value: '12',
                //     label: 'Dec'
                // }],
                inputFromDate: [],

                FPSListInt: [],

                /* FPSList: [
                    {
                        prop: "Index_No",
                        label: "Student No"
                    },{
                        prop: "Full_Name",
                        label: "Full Name"
                    },{
                        prop: "Middle_name",
                        label: "Middle Name"
                    },{
                        prop: "Last_name",
                        label: "Last Name"
                    },{
                        prop: "DOB_Convert",
                        label: "DOB"
                    },{
                        prop: "student_type",
                        label: "Student Type"
                    },{
                        prop: "Nationality",
                        label: "Nationality"
                    },{
                        prop: "sex",
                        label: "Gender"
                    },{
                        prop: "ID_Number",
                        label: "ID Number"
                    }, {
                        prop: "id_type",
                        label: "ID Type"
                    },{
                        prop: "CourseProgrammeName",
                        label: "Course Name"
                    },{
                        prop: "SCRS_From_Date_Convert",
                        label: "Course From Date"
                    },{
                        prop: "SCRS_To_Date_Convert",
                        label: "Course To Date"
                    },{
                        prop: "Course_duration",
                        label: "Course Duration in Month"
                    },{
                        prop: "status",
                        label: "Student Status"
                    },{
                        prop: "Amount_Received_From_Student",
                        label: "Amount Received From Student"
                    },{
                        prop: "receiptDate",
                        label: "Amount Received Date"
                    },{
                        prop: "Total_Course_Fee_Payable",
                        label: "Total Course Fee Payable"
                    },{
                        prop: "ProtectionStartDate",
                        label: "Protection Start Date"
                    },{
                        prop: "ProtectionEndDate",
                        label: "Protection End Date"
                    },{
                        prop: "ProtectionAmount",
                        label: "Protection Amount"
                    },{
                        prop: "refundAmount",
                        label: "Amount Refund To Student"
                    },{
                        prop: "nettAmt",
                        label: "Net Amount To Be Protected"
                    },
                ], */

                FPSList: [
                {
                        prop: "SN",
                        label: "SN"
                    },{
                        prop: "Policy_No",
                        label: "Policy No"
                    },{
                        prop: "Policy_Start_Date",
                        label: "Policy Start Date"
                    },{
                        prop: "Policy_End_Date",
                        label: "Policy End Date"
                    },{
                        prop: "Name_of_PEI",
                        label: "Name of PEI"
                    },{
                        prop: "Name_Of_Student",
                        label: "Name of Student"
                    },{
                        prop: "Student_NRIC",
                        label: "Students NRIC/FIN no."
                    },{
                        prop: "Student_Contact",
                        label: "Students Contract no. "
                    },{
                        prop: "Course_Title",
                        label: "Course Title"
                    },{
                        prop: "Course_Start_Date",
                        label: "Course Start Date"
                    }, {
                        prop: "Course_End_Date",
                        label: "Course End Date"
                    },{
                        prop: "Total_Course_Fee_Payable",
                        label: "Total Course Fees Payable"
                    },{
                        prop: "Receipt_Reference_No",
                        label: "Receipt Reference no."
                    },{
                        prop: "Receipt_Date",
                        label: "Receipt Date"
                    },{
                        prop: "Receipt_Amount",
                        label: "Receipt Amount"
                    },{
                        prop: "Receipt_Value_End_Date",
                        label: "Receipt Value End Date"
                    },{
                        prop: "Data_Accuracy_Date",
                        label: "Data Accuracy Date"
                    },
                ],

                pageSize: 50,
            };
        },

        methods: {

            async Search() {
                try {
                    if (!this.inputFromDate[0] || !this.inputFromDate[1]) {
                        this.$notify({
                            title: 'Require',
                            message: '"Please select date from and date to"'
                        });
                    } else {
                        this.$vs.loading();
                         const response = await DataSource.shared.getLibertyReport2(this.inputFromDate[0], this.inputFromDate[1]);

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error 99!'
                                });
                            } else if (response.code === '2') {
                                this.$notify({
                                    title: 'No Record',
                                    message: 'No Record Found'

                                });
                                this.FPSListInt = [];
                            } else {

                                // loop in order to bind diff name for same field from DB, as console will have error with same field name bind
                                //response.Table.forEach(obj => {
                                //    obj.ProtectionStartDate = obj.receiptDate;
                                    //obj.ProtectionEndDate = obj.SCRS_To_Date_Convert ;
                                //    obj.ProtectionAmount = obj.Amount_Received_From_Student;
                                //    }
                                //);
                                this.FPSListInt = response.Table;
                            }
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

//

            DownloadExcel() {  
                let exportFPSExcelObject = [];
                var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
                
                var PEIName = "";
                var AccuracyDateName = "";

                this.FPSListInt.forEach(m => {
                    let tempList = {
                        'SN': m.SN,
                        'Policy No': m.Policy_No,
                        'Policy Start Date': m.Policy_Start_Date,
                        'Policy End Date': m.Policy_End_Date,
                        'Name of PEI': m.Name_of_PEI,
                        'Name of Student': m.Name_Of_Student,
                        'Students NRIC/FIN no.': m.Student_NRIC,
                        'Students Contract no.': m.Student_Contact,
                        'Course Title': m.Course_Title,
                        'Course Start Date': m.Course_Start_Date,
                        'Course End Date': m.Course_End_Date,
                        'Total Course Fee Payable': m.Total_Course_Fee_Payable,
                        'Receipt Reference no.': m.Receipt_Reference_No,
                        'Receipt Date': m.Receipt_Date,
                        'Receipt Amount': m.Receipt_Amount,
                        'Receipt Value End Date': m.Receipt_Value_End_Date,
                        'Data Accuracy Date': m.Data_Accuracy_Date,
                    };
                    PEIName = m.Name_of_PEI;
                    AccuracyDateName = m.Data_Accuracy_Date_Name;
                    
                    exportFPSExcelObject.push(tempList);
                });

                let tempList2 = {
                        'SN': "",
                        'Policy No': "",
                        'Policy Start Date': "",
                        'Policy End Date': "",
                        'Name of PEI': "",
                        'Name of Student': "",
                        'Students NRIC/FIN no.': "",
                        'Students Contract no.': "",
                        'Course Title': "",
                        'Course Start Date': "",
                        'Course End Date': "",
                        'Total Course Fee Payable': "",
                        'Receipt Reference no.': "",
                        'Receipt Date': "",
                        'Receipt Amount': "",
                        'Receipt Value End Date': "",
                        'Data Accuracy Date': ""
                    };
                    exportFPSExcelObject.push(tempList2);

                let tempList3 = {
                        'SN': "",
                        'Policy No': "As of the data accuracy date indicated above, " + PEIName + " declared that these are the new course fees collected from the above students for the month of"
                        
                    };
                    exportFPSExcelObject.push(tempList3);

                    let tempList4 = {
                        'SN': "",
                        'Policy No': "" + AccuracyDateName + ". The utilisation of insurance coverage limit of the PEI is within the approved  Maximum Insurable Limit."
                        
                    };
                    exportFPSExcelObject.push(tempList4);

                var sheet2WS = XLSX.utils.json_to_sheet(exportFPSExcelObject);
                var wb2 = XLSX.utils.book_new(); // make Workbook of Excel
                XLSX.utils.book_append_sheet(wb2, sheet2WS, 'sheet2'); // sheetAName is name of Worksheet
                //XLSX.writeFile(wb2, 'FPS Report - ' + currentDateWithFormat + '.xlsx'); // name of the file is 'book.xlsx'
                XLSX.writeFile(wb2, 'FPS New Report NEW FORMAT - ' + currentDateWithFormat + '.xlsx'); // name of the file is 'book.xlsx'
            },


        }
    };
</script>
<style scoped>
    .tl-search-bar .el-select, .tl-search-bar .el-date-editor {
        margin: 0 10px;
        flex: 1;
    }
    .tl-search-bar button {
        background: #007bff !important;
        color: white;
        border: 0px;
    }

    .tl-search-bar {
        display: flex;
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid #edf0f4;
        margin-bottom: 20px;
    }
</style>